module.exports = require("@mui/material/SvgIcon");